export default {
  accountCollection: [],
};
